import React, { useState } from "react";
import { Field, reduxForm } from "redux-form";
import { Modal } from "antd";
import { CircularProgress } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { components } from "react-select";

import { customInput } from "../../../../../../../common/custom-input";
import { CustomCreatableSingleSelect } from "../../../../../../../common/new-core-ui/CustomSingleSelect";
import FormSelectStyle from "../../../../../../v2FormSelectStyle";
import styles from "../../../../../JobStyle.module.css";

const FORM_NAME = "job_swms_emergency_contact_add_edit_modal";

const normalizeContactNumber = (value) => {
  if (typeof value !== "string") {
    return value;
  }

  return value.replace(/[^0-9+\-\/\s]/g, "");
};

const validate = (values) => {
  const errors = {};

  const emergencyType = values && values.emergency_contact_type;
  const emergencyTypeName = emergencyType
    ? String(emergencyType.label || emergencyType.value || "").trim()
    : "";

  if (!emergencyTypeName) {
    errors.emergency_contact_type = "Emergency Type is required.";
  }

  if (!values || !values.contact_name || !String(values.contact_name).trim()) {
    errors.contact_name = "Contact Name is required.";
  }

  if (!values || !values.contact_number || !String(values.contact_number).trim()) {
    errors.contact_number = "Phone Number is required.";
  }

  return errors;
};

function EmergencyContactAddEditModal({
  visible,
  mode = "Add",
  handleSubmit,
  onClose,
  typeOptions = [],
  lockType = false
}) {
  const [saving, setSaving] = useState(false);

  const onModalSubmit = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    handleSubmit(onSubmit)(event);
  };

  const onSubmit = (values) => {
    const emergencyType = values && values.emergency_contact_type;

    setSaving(true);

    onClose(true, {
      emergency_contact_type: emergencyType,
      contact_name: String(values.contact_name).trim(),
      phone_number: String(values.contact_number).trim()
    });

    setSaving(false);
  };

  return (
    <Modal
      className="cs-modal-v2"
      centered
      footer={null}
      visible={visible}
      onCancel={() => onClose(false)}
      destroyOnClose
      maskClosable={false}
      bodyStyle={{ paddingRight: "0px", paddingLeft: "0px" }}
      width={700}
      getContainer={() => document.body}
      closeIcon={<div className={styles.ModalCloseIcon}><CloseIcon /></div>}
    >
      <div className="v2-modal-container">
        <form onSubmit={onModalSubmit}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className={styles.ModalHeading}>{mode === "Edit" ? "Edit Emergency Contact" : "Add Emergency Contact"}</div>
                <hr />
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-12">
                <div className={styles.Label}>Emergency Type</div>
                <Field
                  name="emergency_contact_type"
                  component={CustomCreatableSingleSelect}
                  styles={FormSelectStyle}
                  placeholder="Select or type to add new emergency type"
                  options={typeOptions}
                  otherProps={{
                    isDisabled: saving || lockType,
                    hideSelectedOptions: false,
                    components: { dropdownIndicator: <components.DownChevron /> },
                    noOptionsMessage: () => "No Options Available."
                  }}
                />
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-6">
                <div className={styles.Label}>Contact Name</div>
                <Field
                  component={customInput}
                  name="contact_name"
                  disabled={saving}
                  autoComplete="off"
                  className={styles.TextField}
                  maxLength={80}
                />
              </div>
              <div className="col-6">
                <div className={styles.Label}>Phone Number</div>
                <Field
                  component={customInput}
                  name="contact_number"
                  normalize={normalizeContactNumber}
                  disabled={saving}
                  autoComplete="off"
                  className={styles.TextField}
                  maxLength={30}
                />
              </div>
            </div>

            <div className="row mt-2">
              <div className="col-12 d-flex align-items-center justify-content-end" style={{ gap: "10px" }}>
                {saving ? <CircularProgress size={20} /> : null}
                <button type="button" className={styles.OutlinedButton} onClick={() => onClose(false)} disabled={saving}>
                  Cancel
                </button>
                <button type="submit" className={styles.PrimaryButton} disabled={saving}>
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
}

export default reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: true,
  enableReinitialize: true,
  validate
})(EmergencyContactAddEditModal);
